import { IFormInfo } from '../form-fileds.model';

export const TE_SAF_FORM_INFO: IFormInfo = {
  name: {
    label: 'మీ పేరు',
    placeholder: 'మీ పేరును నమోదు చేయండి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి మీ పేరును నమోదు చేయండి',
      pattern: 'దయచేసి సరైన పేరు నమోదు చేయండి',
      minLength: 'పేరులో కనీసం 3 అక్షరాలు ఉండాలి'
    }
  },
  email: {
    label: 'ఈమెయిల్',
    placeholder: 'ఈమెయిల్ నమోదు చేయండి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి మీ ఈమెయిల్ నమోదు చేయండి',
      pattern: 'దయచేసి సరైన ఈమెయిల్ నమోదు చేయండి'
    }
  },
  raisingFor: {
    label: 'మీరు ఎవరికోసం నిధులు సేకరిస్తున్నారా?',
    placeholder: '',
    readOnly: false,
    options: [
      { value: 'self', label: 'నేను', icon: 'people' },
      { value: 'someoneElse', label: 'రెండవ వ్యక్తి', icon: 'people' },
      { value: 'ngo', label: 'ఎన్‌జిఒ/చారిటీ', icon: 'people' }
    ],
    errMsg: { required: 'దయచేసి ఒక ఎంపికను ఎంచుకోండి' }
  },
  ngo: {
    label: 'ఎన్‌జిఒ పేరు',
    placeholder: 'పేరు నమోదు చేయండి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి మీ ఎన్జీఓని శోధించి ఎంపిక చేయండి',
      ngoNotFound: 'ఎన్జీఓ నమోదు కాలేదు',
      custom: 'దయచేసి ఇతర ఎన్జీఓను ఎంపిక చేయండి'
    }
  },
  relation: {
    label: 'ఈ నిధులు నా కోసం...',
    placeholder: 'లేదా ఇతరాన్ని ఎంచుకోండి',
    readOnly: false,
    priorOptions: [
      { value: 'Mother', label: 'తల్లి' },
      { value: 'Father', label: 'తండ్రి' },
      { value: 'Son', label: 'మ కుమారుడు' },
      { value: 'Daughter', label: 'కుమార్తె' },
      { value: 'Friend', label: 'మిత్రుడు' },
    ],
    options: [
      { value: 'Aunt', label: 'అత్త లేదా మావయ్య' },
      { value: 'Brother', label: 'సోదరుడు' },
      { value: 'Cousin', label: 'మామమ్మై/మేమ్మె' },
      { value: `Friend's Family`, label: `స్నేహితుని కుటుంబం` },
      { value: 'Granddaughter', label: 'మరునాన్నాయి/మరుమనిషి' },
      { value: 'Grandfather', label: 'తాతయ్య/నాన్నయ్య' },
      { value: 'Grandmother', label: 'ముత్తాతయ్య/నాన్నమ్మ' },
      { value: 'Grandson', label: 'మనమ్మాయి/మానిషి' },
      { value: 'Husband', label: 'భర్త' },
      { value: 'Legal ward', label: 'చట్టబద్దంగా సంరక్షణలో ఉన్నవారు' },
      { value: 'Nephew', label: 'ముత్తం బెఅ ధ్వెను? (Nephew)' },
      { value: 'Niece', label: 'నెవె? (Niece)' },
      { value: 'Relative', label: 'బంధువులు' },
      { value: 'Sister', label: 'ఆక్క/చెలి' },
      { value: 'Twins', label: 'యమల పుట్టిన పిల్లలు' },
      { value: 'Uncle', label: 'అత్త/చూలియ' },
      { value: 'Wife', label: 'భార్య' },
      { value: 'Pet', label: 'పెంపుడు పశువు' },
      { value: 'Other', label: 'ఇతరులు' },
    ],
    errMsg: { required: 'దయచేసి ఒక ఎంపికను ఎంచుకోండి' }
  },
  beneficiaryName: {
    label: 'ప్రత్యర్ధి పేరు',
    placeholder: 'ప్రత్యర్థికి పేరు నమోదు చేయండి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి ప్రత్యర్థి పేరును నమోదు చేయండి',
      pattern: 'దయచేసి సరైన పేరు నమోదు చేయండి',
      minLength: 'పేరులో కనీసం 3 అక్షరాలు ఉండాలి'
    }
  },
  age: {
    label: 'వయసు వర్గం?',
    options: [
      { value: '0-5', label: '0‑5 సంవత్సరాలు', icon: 'person' },
      { value: '5-18', label: '5‑18 సంవత్సరాలు', icon: 'person' },
      { value: '18-60', label: '18‑60 సంవత్సరాలు', icon: 'person' },
      { value: '60+', label: '60+ సంవత్సరాలు', icon: 'person' },
    ],
    errMsg: { required: 'దయచేసి ఒక ఎంపికను ఎంచుకోండి' }
  },
  fundRequired: {
    label: 'మీరు ఎంత నిధులు సేకరించాలనుకుంటున్నారు?',
    prefix: '₹',
    placeholder: '000000',
    readOnly: false,
    note: 'ప్రారంభానికి ఒక సుమారుగా నమోదు చేసి తర్వాత మార్చవచ్చు. కనీసం ₹2000 ఉండాలి',
    errMsg: {
      required: 'దయచేసి మొత్తం నమోదు చేయండి',
      min: 'దయచేసి ₹2000 లేదా అంతకంటే ఎక్కువ నమోదు చేయండి',
      max: 'దయచేసి ₹5,00,00,000 కన్నా తక్కువ లేదా సమానమైన మొత్తం నమోదు చేయండి'
    }
  },
  cause: {
    label: 'ఈ దానపు అభివృద్ధి లక్ష్యం ఏది?',
    readOnly: false,
    showMore: 'మరింత కారణాలను చూడండి',
    showLess: 'తక్కువ కారణాలను చూపండి',
    errMsg: { required: 'దయచేసి ఒక ఎంపికను ఎంచుకోండి' }
  },
  ailment: {
    label: 'అసాధారణ/వైద్య పరిస్థితి',
    placeholder: 'శోధించి, ఎంపిక చేయండి',
    readOnly: false,
    errMsg: { required: 'దయచేసి నమోదు చేసి ఎంపిక చేయండి' }
  },
  hospitalisation: {
    label: 'మీ ఆసుపత్రి ప్రవేశ స్థితి ఏమిటి?',
    readOnly: false,
    options: [
      { value: 'Recently discharged from the hospital', label: 'టətli దగ్గర విడుదల', icon: 'people' },
      { value: 'Currently hospitalised', label: 'ప్రస్తుతం ప్రవేశించారు', icon: 'people' },
      { value: 'Will be hospitalised soon', label: 'త్వరలో ప్రవేశిస్తారు', icon: 'people' },
    ],
    lowPriorOptions: [
      { value: 'Does not require hospitalisation', label: 'ప్రవేశం అవసరం లేదు', icon: 'block' },
    ],
    errMsg: { required: 'దయచేసి ఒక ఎంపికను ఎంచుకోండి' }
  },
  hospital: {
    label: 'ఆసుపత్రి పేరు',
    placeholder: 'ఆసుపత్రిని ఎంచుకోండి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి ఆసుపత్రిని ఎంచుకోండి'
    }
  },
  sameCityAsHospital: {
    label: 'నేను ఆసుపత్రి ఉన్న నగరంలో ఉన్నాను',
    readOnly: false
  },
  city: {
    label: 'నగరం',
    placeholder: 'నగరం నమోదు చేయండి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి నగరం నమోదు చేయండి',
      custom: 'దయచేసి చెల్లుబాటు అయ్యే నగరాన్ని ఎంచుకోండి'
    }
  },
  title: {
    label: 'నిధుల కోసం శీర్షిక',
    placeholder: 'శీర్షిక నమోదు చేయండి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి శీర్షిక నమోదు చేయండి',
      minLength: 'కనీసం 5 అక్షరాలు అవసరం',
      maxLength: 'గరిష్టంగా 75 అక్షరాలు అనుమతించబడతాయి'
    }
  },
  about: {
    label: 'உங்கள் கதையை நாங்கள் எழுதினோம் — எப்போது வேண்டுமானாலும் திருத்தலாம்',
    label1: 'இந்த நிதி திரட்டல் உங்களுக்கு ஏன் முக்கியம் என்பதை விளக்குங்கள்',
    label2: 'உங்கள் கதையை கூறுங்கள்',
    placeholder: 'உங்கள் நோக்கத்தை நியாயப்படுத்தும் மற்றும் ஆதரவாளரை காணொளி செய்ய வைக்கும் கதையை எழுதுங்கள்',
    readOnly: false,
    errMsg: {
      required: 'இந்த புலம் தேவை',
      minLength: 'కనీసం 50 అక్షరాలు అవసరం'
    }
  },
  aboutMerge: {
    label: 'నిధులను ఏ ప్రయోజనం కోసం ఉపయోగించబోతున్నారు?',
    placeholder: 'ట్యూషన్, ప్రయాణం, పుస్తకాలు మొదలైనవి',
    readOnly: false,
    errMsg: {
      required: 'దయచేసి ఉపయోగాన్ని నమోదు చేయండి'
    }
  },
  media: {
    label: `మీ లక్ష్యాన్ని మద్దతు ఇవ్వడానికి ఫోటోను అప్లోడ్ చేయండి <span class="optional">(ఐచ్ఛికం)</span>`,
    readOnly: false
  },

  insuranceOptIn: {
    label: `నేను ఎంచుకున్న కుటుంబ సభ్యునికి <strong>₹1.2 లక్షల బీమా కవర్</strong> కోసం నిధులను సేకరించడానికి నేను అంగీకరిస్తున్నాను.`,
    readOnly: false,
  },
  agree: {
    label: `నేను కెట్టో యొక్క <a href="{{terms}}" target="_blank">వినియోగ నిబంధనలు</a>, <a href="{{privacy}}" target="_blank">గోప్యతా విధానం</a>, మరియు <a href="{{plans}}" target="_blank">పథకాలు మరియు ధరల వివరాలు</a>ను అంగీకరిస్తున్నాను. పైన అందించిన సమాచారం నా జ్ఞానం మరియు నమ్మకంతో సరైనదని నేను ధృవీకరిస్తున్నాను. ఈ సమాచారం తప్పుడు లేదా మోసపూరితంగా ఉన్నట్లయితే నేను బాధ్యత వహిస్తాను. నేను దీనిని నియంత్రణ సంస్థలతో పంచుకోవడానికి లేదా చట్ట ప్రకారం వెల్లడించడానికి నా సమ్మతిని ఇస్తున్నాను.`,
    readOnly: false,
    errMsg: { required: 'దయచేసి ఒప్పందం చదవండి మరియు ఎంచుకోండి' }
  }
};

export const TE_OTHER_INFO = {
  verifyEmail: {
    title: 'ఒకసారి నిర్ధారించిన తర్వాత మీరు ఈమెయిల్‌ను మార్చలేరు',
    confirm: 'నిర్ధారించు',
    edit: 'సవరించు'
  },
  verifyEmailOTP: {
    title: `ఇమెయిల్‌కు పంపిన OTPని నమోదు చేయండి`,
    confirm: 'ధృవీకరించండి',
    edit: 'ఇమెయిల్‌ను సవరించు'
  }
};
